exports.gender = [
    {
      id: 1,
      gender: "Men"
    },
    {
      id: 2,
      gender: "Women"
    },
    {
      id: 3,
      gender: "Younger Child"
    },
    {
      id: 4,
      gender: "Older Child"
    }
  ]

  exports.ProPrice = [
    {
      id: 1,
      price: "Under-1500"
    },
    {
      id: 1,
      price: "1500-3500"
    },
    {
      id: 1,
      price: "3500-7000"
    },
    {
      id: 1,
      price: "7000-10500"
    },
    {
      id: 1,
      price: "10500-15000"
    },
    {
      id: 1,
      price: "30000-Over"
    },
  ]

  exports.ProColor = [
    {
      id: 1,
      color: 'bg-purple-700 ',
      colorName: "Purple"
    },
    {
      id: 1,
      color: 'bg-red-700',
      colorName: "Red"
    },
    {
      id: 1,
      color: 'bg-black',
      colorName: "Black"
    },
    {
      id: 1,
      color: 'bg-blue-500',
      colorName: "Blue"
    },
    {
      id: 1,
      color: 'bg-white',
      colorName: "White"
    },
    {
      id: 1,
      color: 'bg-amber-700',
      colorName: "Brown"
    },
    {
      id: 1,
      color: 'bg-green-700',
      colorName: "Green"
    },
    {
      id: 1,
      color: 'bg-gray-700',
      colorName: "Gray"
    },
    {
      id: 1,
      color: 'bg-pink-700',
      colorName: "Pink"
    },
    {
      id: 1,
      color: 'bg-yellow-500',
      colorName: "Yellow"
    },
  ]

  exports.proRating = [
    {
      id: 1,
      rating: '3 ★ & above',
    },
    {
      id: 1,
      rating: '4 ★ & above',
    },
  ]

  exports.size = [
      'UK 6 (EU 40)',
      'UK 6.5',
      'UK 7',
      'UK 7.5',
     'UK 8',
     'UK 8.5',
     'UK 9',
     'UK 9.5',
     'UK 10',
     'UK 10.5',
     'UK 11',
    'UK 11.5',
     'UK 12',
  ]